import { colors, fontWeights, fontSizes, spacing, Body2 } from 'ui/theme';
import styled from 'styled-components';

export const SplitTitle = styled(Body2)`
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.half};
`;

export const BaseRow = styled.div`
  display: flex;
  align-items: center;
  button {
    margin-left: ${spacing.half};
  }
`;

export const SplitList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  > :not(:last-child) {
    margin-bottom: ${spacing.half};
  }
`;

export const SplitItem = styled(BaseRow).attrs({ as: 'li' })`
  > :first-child {
    flex: 0;
  }
`;

export const AddMoreSplits = styled(BaseRow)`
  gap: ${spacing.eighth};
`;

export const RetryLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;

export const InvalidSplits = styled.span`
  color: ${colors.red100};
  padding-left: ${spacing.threeQuarter};
  font-size: ${fontSizes.s14};
`;
